export const EVENT = 'user_interaction'
export const EVENT_CATEGORY = 'lp_roulette'
export const ACTION_TYPE = {
  CLICK_TASKS: 'click_tasks',
  CLICK_AWARDS: 'click_awards',
  CLICK_CATCH_AWARD: 'click_catch_award',
  CLICK_TAKE_AWARD: 'click_take_award',
}

export const TYPE = {
  GTM_4: 'gtm_4',
}
